import './RoundedGrayBox.scss';

const RoundedGrayBox = (props: any) => {
    const children = props.children;
    return <div className="rounded-gray-box">
        {children}
    </div>;
}

export default RoundedGrayBox;